export type AcademyStep = {
  number: string
  title: string
  text: string
}

export const academySteps: AcademyStep[] = [
  {
    number: '1',
    title: 'Lifetime Zugang zur High-Ticket Sales Academy',
    text: 'Einmal Teil der Academy, immer Teil der Academy – du erhältst lebenslangen Zugang zu allen Inhalten und Ressourcen. Ob du dein Wissen vertiefen, neue Strategien lernen oder dich an aktuellen Trends orientieren möchtest – wir stehen dir dauerhaft zur Seite.',
  },
  {
    number: '2',
    title: 'Persönliche 1:1 Betreuung',
    text: 'Unsere erfahrenen Mentoren stehen dir individuell zur Seite, um deine Stärken zu fördern, deine Schwächen zu erkennen und dich optimal auf deinen Weg als High-Ticket Sellerin vorzubereiten. Diese persönliche Betreuung kann dir maximale Ergebnisse liefern.',
  },
  {
    number: '3',
    title: 'Regelmäßige Q&A-Calls',
    text: 'Stelle all deine Fragen in unseren regelmäßigen Q&A-Sessions und erhalte klare Antworten sowie praxisorientierte Lösungen. Unsere Experten teilen wertvolle Insights und helfen dir, Hindernisse schnell und effektiv zu überwinden.',
  },
  {
    number: '4',
    title: 'Mindset-Calls',
    text: 'Erfolgreicher High-Ticket-Sales beginnt im Kopf. Unsere Mindset-Calls helfen dir dabei, dein Denken neu zu strukturieren, limitierende Glaubenssätze loszulassen und das Selbstbewusstsein aufzubauen, das für Spitzenleistungen notwendig ist.',
  },
  {
    number: '5',
    title: 'Externe Trainer aus der High-Ticket-Branche',
    text: 'Lerne von den Besten der Branche: Unsere externen Trainer sind aktive High-Ticket-Closer mit Erfolgen im 7- und 8-stelligen Bereich. Sie teilen mit dir exklusive Strategien und praxiserprobte Techniken, die wirklich funktionieren.',
  },
  {
    number: '6',
    title: 'WhatsApp-Support',
    text: 'Du stehst vor einer Herausforderung oder hast eine Frage? Unser Team ist nur eine Nachricht entfernt. Mit unserem direkten WhatsApp-Support erhältst du schnelle Unterstützung, wann immer du sie brauchst.',
  },
  {
    number: '7',
    title: 'Sales Mastermind-Veranstaltungen in Dubai & Miami',
    text: 'Starte deine Reise in zwei der aufregendsten Städte der Welt! Unsere exklusiven Sales Mastermind-Events in Dubai und Miami bieten nicht nur erstklassige Trainings, sondern auch die Möglichkeit, wertvolle Kontakte zu knüpfen und Teil einer globalen Erfolgs-Community zu werden.',
  },
  {
    number: '8',
    title: 'Live-Trainings',
    text: 'Praxisnähe wird bei uns großgeschrieben. In unseren wöchentlichen Live-Trainings vertiefst du dein Wissen, trainierst echte Gespräche, erhältst direktes Feedback von unseren Expertinnen und kannst jederzeit all deine Fragen stellen.',
  },
  {
    number: '9',
    title: 'Eine einzigartige Community',
    text: 'Du bist nicht allein auf deinem Weg. In unserer Community triffst du auf ambitionierte Frauen mit ähnlichen Zielen, kannst dich austauschen, Fragen stellen, Erfahrungen teilen und wertvolle Kontakte knüpfen. Ein Umfeld, das dich motiviert, unterstützt und gemeinsam mit dir wächst.',
  },
  {
    number: '10',
    title: 'Begleitung in deinen Remote Job',
    text: 'Nach ca. 8 Wochen bist du bereit, deine Sales-Skills in der Praxis einzusetzen – und genau da lassen wir dich nicht allein. Wir begleiten dich bei der Suche nach einem Remote Job, der wirklich zu dir passt, und zeigen dir, wie du dich bei passenden Unternehmen positionierst. Dabei profitierst du von unserem internationalen Netzwerk aus Unternehmen, Coaches und Dienstleistern und erhältst Zugang zu wertvollen Kontakten und Möglichkeiten. Wir begleiten dich von deinen ersten Schritten bis hin zu deinen ersten erfolgreichen Abschlüssen.',
  },
]
